// Property Factory
export const PropertyFactory = (propertyData = {}) => {
    return {
      propertyId: propertyData.Property_ID || propertyData.propertyId || "",
      propertyName: propertyData.Property_Name || propertyData.propertyName || "",
      country: propertyData.Country || propertyData.country || "United Kingdom",
      addressLine1: propertyData.AddressLine1 || propertyData.addressLine1 || "",
      addressLine2: propertyData.AddressLine2 || propertyData.addressLine2 || "",
      addressLine3: propertyData.AddressLine3 || propertyData.addressLine3 || "",
      city: propertyData.City || propertyData.city || "",
      postcode: propertyData.Postcode || propertyData.postcode || "",
      state: propertyData.state || "",
      propertyStatus: propertyData.Property_Status || propertyData.propertyStatus || "Not Validated",
      transactionStatus: propertyData.transaction_status || propertyData.transactionStatus || "",
      titleNumbers: propertyData.Title_Numbers || propertyData.titleNumbers || "",
      registrationDescription: propertyData.Registration_Description || propertyData.registrationDescription || "",
    };
  };